import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import IconPlayCircle from './Icons/IconPlayCircle';


const CtaButton = ({ history, small, playIcon, text, textSub, href, onClick, className, style }) => {
  const handleClick = onClick ? () => onClick(href) : () => history.push(href);
  return (
    <button className={`cta-button${small ? ' sm' : ''} ${className || ''}`} style={style} onClick={handleClick}>
      <span>{text}</span>
      {playIcon
        ? (
          <span className="ml-2">
            <IconPlayCircle className="icon" fill="#374C53" />
          </span>
        ) : null
      }
      {textSub ? <span className="sub">{textSub}</span> : null}
    </button>
  );
};

CtaButton.propTypes = {
  small: PropTypes.bool,
  text: PropTypes.string.isRequired,
  textSub: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  playIcon: PropTypes.bool,
};

CtaButton.defaultProps = {
  small: false,
  playIcon: false,
};

export default withRouter(CtaButton);



// WEBPACK FOOTER //
// ./src/components/CtaButton.js